


































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import { saveAs } from "file-saver";
import { wrapCarouselIndex } from "./wrapCarouselIndex";

@Component({
  computed: {
    ...mapState("ubic", ["token"])
  }
})
export default class Attachments extends Vue {
  @Prop({ type: Boolean, default: false }) carousel!: boolean;
  @Prop() read_only!: boolean;
  @Prop() small!: boolean;
  @Prop() attachments!: any;
  @Prop() throw_data!: any;
  @Prop({ type: Function }) removeFile!: Function;
  @Prop({ type: Function }) addAttachments!: Function;
  @Prop({ type: Number, default: null }) height!: number | null;
  @Prop({ type: Boolean, default: false }) downloadOnly!: boolean;

  dropFiles: any = [];
  token!: any;
  loading: boolean = false;
  loaded: boolean = false;
  content: any[] = [];
  activeIndex: number = 0;
  contentGeneration: number = 0;

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  get activeFile() {
    return this.content[this.activeIndex] || { data: "", mime: "image" };
  }

  get hasFixedHeight() {
    return (
      typeof this.height === "number" &&
      !Number.isNaN(this.height) &&
      this.height > 0
    );
  }

  get mediaStyle() {
    if (!this.hasFixedHeight) {
      return null;
    }
    return { maxHeight: `${this.height}px` };
  }

  get slideStyle() {
    if (!this.hasFixedHeight) {
      return null;
    }
    return { minHeight: `${this.height}px` };
  }

  get rootClasses() {
    const classes: string[] = [];
    if (this.small) {
      classes.push("small");
    }
    if (this.downloadOnly) {
      classes.push("download-only");
    }
    return classes;
  }

  downloadLabel(file: { name?: string; data?: string }, index: number) {
    if (file && file.name) {
      return file.name;
    }
    return `Файл ${index + 1}`;
  }

  parseContentDisposition(header: string | null): string | null {
    if (!header) {
      return null;
    }

    const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match) {
      try {
        return decodeURIComponent(utf8Match[1]);
      } catch {
        return utf8Match[1];
      }
    }

    const quotedMatch = header.match(/filename="([^"]+)"/i);
    if (quotedMatch) {
      return quotedMatch[1];
    }

    const plainMatch = header.match(/filename=([^;]+)/i);
    return plainMatch ? plainMatch[1].trim() : null;
  }

  removeFileAction(index: number) {
    const file = this.content[index];
    const fileName = this.downloadLabel(file, index);

    this.$buefy.dialog.confirm({
      message: `Удалить вложение «${fileName}»?`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      type: "is-danger",
      onConfirm: () => {
        this.removeFile(index, this.throw_data);
      }
    });
  }

  prevSlide() {
    this.setActiveIndex(this.activeIndex - 1);
  }

  nextSlide() {
    this.setActiveIndex(this.activeIndex + 1);
  }

  setActiveIndex(index: number) {
    const nextIndex = wrapCarouselIndex(index, this.content.length);
    this.activeIndex = nextIndex;
    const file = this.content[nextIndex];
    console.debug("[Attachments.carousel]", {
      index: nextIndex,
      total: this.content.length,
      mime: file && file.mime
    });
  }

  public openViewer(startIndex: number) {
    const images = this.content
      .filter((file: any) => file && file.mime === "image")
      .map((file: any) => ({
        src: file.data,
        alt: file.name || ""
      }));

    if (images.length === 0) {
      return;
    }

    const viewerIndex = Math.min(
      Math.max(0, startIndex),
      images.length - 1
    );

    // @ts-ignore — VueViewer 1.x exposes the imperative API as $viewerApi().
    this.$viewerApi({
      images,
      options: {
        initialViewIndex: viewerIndex
      }
    });
  }

  @Watch("attachments")
  onAttachmentsChange() {
    this.setContent();
  }

  public mounted() {
    this.setContent();
  }

  public setContent() {
    const generation = ++this.contentGeneration;
    this.loaded = false;
    this.loading = true;
    this.content = [];
    this.activeIndex = 0;

    if (!this.attachments || this.attachments.length === 0) {
      this.loaded = true;
      this.loading = false;
      return;
    }

    const results: Array<{
      id: string;
      data: string;
      mime: string;
      name?: string;
    } | null> = new Array(this.attachments.length);
    let pending = this.attachments.length;

    const finalizeOne = () => {
      if (generation !== this.contentGeneration) {
        return;
      }

      pending -= 1;
      if (pending === 0) {
        this.content = results.filter(
          (
            item
          ): item is {
            id: string;
            data: string;
            mime: string;
            name?: string;
          } => item !== null
        );
        this.loaded = true;
        this.loading = false;
        this.activeIndex = wrapCarouselIndex(
          this.activeIndex,
          this.content.length
        );
        console.debug("[FIX][Attachments.setContent] loaded", {
          generation,
          count: this.content.length
        });
      }
    };

    this.attachments.forEach((file: any, index: number) => {
      const url =
        this.FILES_HOST +
        "/api/v1/files/download_preview/" +
        file.id +
        "?authorization=" +
        this.token;
      const request = new XMLHttpRequest();
      request.open("GET", url, true);
      request.responseType = "blob";
      request.onload = () => {
        if (generation !== this.contentGeneration) {
          return;
        }

        const fileName =
          this.parseContentDisposition(
            request.getResponseHeader("Content-Disposition")
          ) ||
          file.name ||
          file.filename;

        const reader = new FileReader();
        reader.readAsDataURL(request.response);
        reader.onload = (e: any) => {
          if (generation !== this.contentGeneration) {
            return;
          }

          const mime = e.target.result.split(";")[0].split(":")[1].split("/")[0];
          results[index] = {
            id: file.id,
            data: e.target.result,
            mime,
            name: fileName
          };
          finalizeOne();
        };
        reader.onerror = () => finalizeOne();
      };
      request.onerror = () => finalizeOne();
      request.send();
    });
  }

  public downloadFile(file: { id?: string; data?: string; name?: string }) {
    if (!file) {
      return;
    }

    const fileName = file.name || "file";

    if (file.id) {
      const fileUrl =
        this.FILES_HOST +
        "/api/v1/files/download_preview/" +
        file.id +
        "?authorization=" +
        this.token;

      fetch(fileUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`download failed: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          saveAs(blob, fileName);
        })
        .catch(error => {
          console.error("[Attachments.downloadFile] error", error);
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: "Не удалось скачать файл"
          });
        });
      return;
    }

    if (file.data && file.data.indexOf("base64,") > -1) {
      saveAs(file.data, fileName);
    }
  }

  uploadFileAction(files: File[]) {
    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);

      // @ts-ignore
      this.$http.post(`/api/v1/files`, formData, {}).then((response: any) => {
        this.addAttachments(response.data.file, this.throw_data);
      });
    }
    this.dropFiles = [];
  }
}
